import styled from 'styled-components';
import { Row } from '@simplywallst/ui-core';

export const MainContainer = styled('section')`
  width: 100%;
  background-color: ${({ theme }) => theme.color.white};
`;

export const HeaderContainer = styled(Row)`
  background-color: ${({ theme }) => theme.color.brand04RGBA(0.2)};
  width: 100%;
`;

export const NavContainer = styled('div')`
  padding: ${({ theme }) => theme.x2spacePx}px;
`;
